import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash, faUtensils, faReceipt, faClock, faCheckCircle, faTimes, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor, useParams, useLocation } from "react-router-dom";
import moneda from '../moneda';
import OrderTrackingModal from '../OrderTrackingModal/OrderTrackingModal';

export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [tipoPedido, setTipoPedido] = useState('delivery'); // 'delivery' | 'mesa'
    const [numeroMesa, setNumeroMesa] = useState('');
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [tienda, setTienda] = useState(null);
    const [mesasDisponibles, setMesasDisponibles] = useState([]);
    const [enviandoPedido, setEnviandoPedido] = useState(false);
    const [modalCuentaClienteOpen, setModalCuentaClienteOpen] = useState(false);
    const [comandasMesaCliente, setComandasMesaCliente] = useState([]);
    const [loadingCuentaCliente, setLoadingCuentaCliente] = useState(false);
    const haAutoAbiertoRef = useRef(false);
    const { idTienda } = useParams();
    const routerLocation = useLocation();

    const abrirCuentaCliente = async (mesaParam, idTiendaParam) => {
        const mesa = mesaParam || numeroMesa;
        if (!mesa) return;
        setLoadingCuentaCliente(true);
        setModalCuentaClienteOpen(true);
        try {
            const tiendaId = idTiendaParam !== undefined ? idTiendaParam : (tienda?.idTienda || '');
            const res = await fetch(`${baseURL}/comandasGet.php?idTienda=${tiendaId}&mesa=${encodeURIComponent(mesa)}&activas=1`);
            const data = await res.json();
            if (data.status === 'success') {
                setComandasMesaCliente(data.comandas || []);
            } else {
                setComandasMesaCliente([]);
            }
        } catch (err) {
            console.error('Error al cargar cuenta del cliente:', err);
            setComandasMesaCliente([]);
        } finally {
            setLoadingCuentaCliente(false);
        }
    };

    // Detección automática de mesa: ÚNICA Y EXCLUSIVAMENTE si el parámetro ?mesa= está en la URL actual de esta tienda
    useEffect(() => {
        try {
            const searchParams = new URLSearchParams(routerLocation.search);
            const paramMesa = searchParams.get('mesa');

            // Solo si la URL actual tiene explícitamente ?mesa=...
            if (paramMesa && paramMesa.trim()) {
                const clean = paramMesa.trim();
                const nombreMesa = clean.toLowerCase().startsWith('mesa') ? clean : `Mesa ${clean}`;
                setTipoPedido('mesa');
                setDeliveryOption('mesa');
                setNumeroMesa(nombreMesa);

                if (!haAutoAbiertoRef.current) {
                    haAutoAbiertoRef.current = true;
                    abrirCuentaCliente(nombreMesa, tienda?.idTienda);
                }
            } else {
                // Si la URL NO tiene el parámetro ?mesa= (ejemplo: inicio '/', otra tienda como Moda-Kata, etc.)
                // Limpiar ABSOLUTAMENTE todo estado de mesa para que NO se muestre el botón flotante ni el modal
                setNumeroMesa('');
                setTipoPedido('delivery');
                setDeliveryOption('delivery');
                setModalCuentaClienteOpen(false);
                setComandasMesaCliente([]);
                haAutoAbiertoRef.current = false;
                localStorage.removeItem('club_mesa_activa');
            }
        } catch (e) {
            console.error('Error al detectar mesa en Cart:', e);
        }
    }, [routerLocation.pathname, routerLocation.search, tienda?.idTienda]);

    // Si la tienda cargada NO es modo lista / restaurante, asegurar que se limpie cualquier estado de mesa
    useEffect(() => {
        if (tienda && tienda.modo_vista !== 'lista' && tienda.modoVista !== 'lista') {
            setNumeroMesa('');
            setModalCuentaClienteOpen(false);
            setComandasMesaCliente([]);
        }
    }, [tienda]);

    // Si la tienda termina de cargar y el modal está abierto sin pedidos, reintentar consulta con idTienda
    useEffect(() => {
        if (tienda?.idTienda && numeroMesa && modalCuentaClienteOpen && comandasMesaCliente.length === 0) {
            abrirCuentaCliente(numeroMesa, tienda.idTienda);
        }
    }, [tienda?.idTienda]);

    useEffect(() => {
        cargarContacto();
    }, []);

    // Cargar mesas cuando se define la tienda
    useEffect(() => {
        if (tienda?.idTienda) {
            fetch(`${baseURL}/mesasGet.php?idTienda=${tienda.idTienda}`)
                .then(r => r.json())
                .then(data => {
                    if (data.status === 'success') {
                        setMesasDisponibles(data.mesas || []);
                    }
                })
                .catch(err => console.error('Error al cargar mesas en Cart:', err));
        }
    }, [tienda]);

    useEffect(() => {
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto?.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    useEffect(() => {
        cargarProductos();
    }, [idTienda, isFocused]);

    // Escuchar cuando la tienda se carga en la vista de detalle
    useEffect(() => {
        const handleTiendaCargada = (e) => {
            if (e.detail) {
                setTienda(e.detail);
            }
        };
        window.addEventListener('tienda-cargada', handleTiendaCargada);
        return () => {
            window.removeEventListener('tienda-cargada', handleTiendaCargada);
        };
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                const tiendasData = data.tiendas || [];
                const productosFlatMap = tiendasData.flatMap(tiendaItem =>
                    (tiendaItem?.productos || []).map(p => ({
                        ...p,
                        modo_vista: tiendaItem.modo_vista,
                        idTienda: p.idTienda || tiendaItem.idTienda,
                        nombreTienda: tiendaItem.nombre
                    }))
                );
                setProductos(productosFlatMap);

                // Detectar idTienda desde la URL actual si existe (ej: /tienda/12/Cliins)
                const urlMatch = window.location.pathname.match(/\/tienda\/(\d+)/);
                const currentTiendaId = idTienda || (urlMatch ? urlMatch[1] : null);

                if (currentTiendaId) {
                    const tiendaSeleccionada = tiendasData.find(t => Number(t.idTienda) === parseInt(currentTiendaId));
                    if (tiendaSeleccionada) {
                        setTienda(tiendaSeleccionada);
                        return;
                    }
                }

                // Detectar por slug en la URL si la ruta es /:slugTienda (ej: /cliins)
                const pathParts = window.location.pathname.split('/').filter(Boolean);
                if (pathParts.length > 0) {
                    const slugOrName = decodeURIComponent(pathParts[0]).toLowerCase();
                    const tiendaMatch = tiendasData.find(t =>
                        (t.nombre && t.nombre.toLowerCase() === slugOrName) ||
                        (t.slug && t.slug.toLowerCase() === slugOrName) ||
                        (t.url && t.url.toLowerCase().includes(slugOrName))
                    );
                    if (tiendaMatch) {
                        setTienda(tiendaMatch);
                        return;
                    }
                }

                const cart = JSON.parse(localStorage.getItem('cart')) || [];
                if (cart.length > 0) {
                    const primerIdTienda = cart[0]?.idTienda;
                    const tiendaCart = tiendasData.find(t => Number(t.idTienda) === Number(primerIdTienda));
                    setTienda(tiendaCart || tiendasData[0] || null);
                } else {
                    setTienda(tiendasData[0] || null);
                }
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const fetchCartItems = () => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        if (cart.length === 0) {
            setCartItems([]);
            setLoading(false);
            return;
        }

        const items = cart.map(cartItem => {
            const producto = productos.find(p => Number(p.idProducto) === Number(cartItem.idProducto));
            return producto ? {
                ...producto,
                cantidad: cartItem.cantidad,
                item: cartItem.item,
                idTienda: cartItem.idTienda || producto.idTienda,
                modo_vista: producto.modo_vista,
            } : {
                idProducto: cartItem.idProducto,
                titulo: cartItem.titulo || 'Producto',
                precio: cartItem.precio || 0,
                cantidad: cartItem.cantidad,
                item: cartItem.item,
                idTienda: cartItem.idTienda,
                modo_vista: cartItem.modo_vista,
            };
        });

        setCartItems(items);
        setLoading(false);
    };

    useEffect(() => {
        fetchCartItems();
    }, [productos, isFocused]);

    useEffect(() => {
        const handleCartUpdate = () => {
            cargarProductos();
            fetchCartItems();
        };

        window.addEventListener('cart-updated', handleCartUpdate);
        window.addEventListener('storage', handleCartUpdate);

        return () => {
            window.removeEventListener('cart-updated', handleCartUpdate);
            window.removeEventListener('storage', handleCartUpdate);
        };
    }, [productos]);

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const defaultMesasMock = [
        { idMesa: 'def-1', numero: 'Mesa 1', estado: 'ocupada' },
        { idMesa: 'def-2', numero: 'Mesa 2', estado: 'ocupada' },
        { idMesa: 'def-3', numero: 'Mesa 3', estado: 'disponible' },
        { idMesa: 'def-4', numero: 'Mesa 4', estado: 'disponible' },
        { idMesa: 'def-5', numero: 'Mesa 5', estado: 'disponible' },
    ];

    const mesasParaMostrar = (mesasDisponibles && mesasDisponibles.length > 0)
        ? mesasDisponibles
        : defaultMesasMock;

    const normalizarMesa = (num) => {
        if (!num) return '';
        return num.toString().trim().toLowerCase().replace(/^mesa\s*/, '');
    };

    const handleSelectMesa = (m) => {
        if (m.estado === 'ocupada') {
            alert(`${m.numero.startsWith('Mesa') ? m.numero : 'Mesa ' + m.numero} está ocupada.`);
            return;
        }
        const nombreMesa = m.numero.startsWith('Mesa') ? m.numero : `Mesa ${m.numero}`;
        setNumeroMesa(nombreMesa);
    };

    const openModalConTipo = (tipo) => {
        setTipoPedido(tipo);
        if (tipo === 'mesa') {
            setDeliveryOption('mesa');
            if (!numeroMesa) {
                const primeraLibre = mesasParaMostrar.find(m => m.estado !== 'ocupada');
                if (primeraLibre) {
                    setNumeroMesa(primeraLibre.numero.startsWith('Mesa') ? primeraLibre.numero : `Mesa ${primeraLibre.numero}`);
                }
            }
        } else {
            setDeliveryOption('delivery');
        }
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        window.dispatchEvent(new CustomEvent('cart-updated'));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
        window.dispatchEvent(new CustomEvent('cart-updated'));
    };

    const [codigos, setCodigos] = useState([]);

    useEffect(() => {
        cargarCodigos();
    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/codigosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    // Detectar si la tienda actual o los productos del carrito son de modo lista / carta restaurante
    const esModoLista = Boolean(
        tienda?.modo_vista === 'lista' ||
        tienda?.modoVista === 'lista' ||
        cartItems.some(item => item?.modo_vista === 'lista' || item?.modoVista === 'lista')
    );

    const handleWhatsappMessage = async () => {
        if (tipoPedido === 'mesa' && !numeroMesa.trim()) {
            alert('Por favor indica el número o nombre de la mesa (ejemplo: Mesa 4).');
            return;
        }

        if (enviandoPedido) return;
        setEnviandoPedido(true);

        const codigoDescuento = codigos.find(item => item.codigo && item.codigo.trim().toUpperCase() === (codigo || '').trim().toUpperCase());
        let descuentoActualizado = 0;

        if (codigoDescuento) {
            descuentoActualizado = parseFloat(codigoDescuento.descuento) || 0;
            setCodigoValido(true);

            // Registrar e incrementar el contador de usos del cupón en la base de datos
            try {
                const formDataUso = new FormData();
                formDataUso.append('codigo', codigoDescuento.codigo);
                formDataUso.append('idCodigo', codigoDescuento.idCodigo);
                fetch(`${baseURL}/codigosUsarPost.php`, {
                    method: 'POST',
                    body: formDataUso
                }).catch(err => console.error('Error al registrar uso de cupón:', err));
            } catch (errUso) {
                console.error('Error al registrar uso de cupón:', errUso);
            }
        } else {
            setCodigoValido(false);
        }

        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });

        let totalPriceWithDiscount = totalPriceCalc - descuentoActualizado;
        if (totalPriceWithDiscount < 0) {
            totalPriceWithDiscount = 0;
        }

        const formattedTotalPrice = totalPriceWithDiscount !== undefined && totalPriceWithDiscount !== null
            ? totalPriceWithDiscount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            : "0.00";

        const phoneNumber = tienda?.telefono || contactos?.telefono || '';

        const cartDetails = cartItems.map((item) => (
            `\n✅ *${item.titulo}* \n       Cantidad: ${item.cantidad}\n       Precio: ${moneda} ${item.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} \n       ${item?.item || ''}`
        ));

        // 1. Guardar primero la comanda en la base de datos para obtener el idComanda
        let idComandaCreada = null;
        try {
            const comandaPayload = {
                idTienda: tienda?.idTienda || 0,
                tipo_pedido: tipoPedido,
                numero_mesa: tipoPedido === 'mesa' ? (numeroMesa.trim() || 'En local') : '',
                cliente_nombre: name.trim(),
                cliente_telefono: '',
                cliente_direccion: location.trim(),
                forma_pago: paymentMethod,
                nota: noteText.trim(),
                codigo_descuento: codigo.trim(),
                descuento: descuentoActualizado,
                total: totalPriceWithDiscount,
                moneda: moneda,
                items_json: cartItems.map(it => ({
                    idProducto: it.idProducto,
                    titulo: it.titulo,
                    precio: it.precio,
                    cantidad: it.cantidad,
                    item: it.item
                }))
            };

            const res = await fetch(`${baseURL}/comandasPost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(comandaPayload)
            });
            const resp = await res.json();
            if (resp.status === 'success' && resp.idComanda) {
                idComandaCreada = resp.idComanda;
                window.dispatchEvent(new CustomEvent('comanda-creada', { detail: resp }));
            }
        } catch (errComanda) {
            console.error('Error al registrar comanda:', errComanda);
        }

        // 2. Construir link de rastreo
        const currentOrigin = window.location.origin;
        const currentPathname = window.location.pathname;
        const trackingLink = idComandaCreada
            ? `${currentOrigin}${currentPathname}?pedido=${idComandaCreada}`
            : '';

        // 3. Armar mensaje de WhatsApp
        let message = '';

        if (tipoPedido === 'mesa') {
            const mesaTexto = numeroMesa.trim() || 'En local';
            let pagoTexto = 'Efectivo al mozo / caja';
            if (paymentMethod === 'transferencia' || paymentMethod === 'yape_plin') {
                pagoTexto = 'Yape / Plin / Transferencia';
            } else if (paymentMethod === 'tarjeta') {
                pagoTexto = 'Tarjeta (Llevar POS a la mesa)';
            }

            let cabeceraMesa = `🍽️ *¡NUEVO PEDIDO EN MESA!*
🏢 *${tienda?.nombre || 'Restaurante'}*
📍 *Mesa:* ${mesaTexto}`;

            if (name.trim()) {
                cabeceraMesa += `\n👤 *Comensal:* ${name.trim()}`;
            }

            cabeceraMesa += `\n\n📋 *DETALLE DE LA ORDEN:*${cartDetails.join('')}
------------------------------------>`;

            if (noteText.trim()) {
                cabeceraMesa += `\n📝 *Indicaciones cocina:* ${noteText.trim()}`;
            }
            cabeceraMesa += `\n💳 *Forma de pago:* ${pagoTexto}`;

            if (codigo.trim() && codigoValido) {
                cabeceraMesa += `\n🎟️ *Cupón aplicado:* ${codigo} (-${moneda} ${descuentoActualizado?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")})`;
            }

            cabeceraMesa += `\n------------------------------------>\n💰 *TOTAL: ${moneda} ${formattedTotalPrice}*`;

            if (trackingLink) {
                cabeceraMesa += `\n\n------------------------------------>\n🔔 *Sigue el estado de tu pedido en vivo aquí:*\n${trackingLink}`;
            }

            message = cabeceraMesa;
        } else {
            let noteMessage = '';
            if (location.trim() !== '') {
                noteMessage += `\n✅ Ubicación: ${location}`;
            }
            if (name.trim() !== '') {
                noteMessage += `\n✅ Nombre: ${name}`;
            }
            if (noteText.trim() !== '') {
                noteMessage += `\n✅ Nota: ${noteText}`;
            }
            if (codigo.trim() !== '') {
                noteMessage += `\n✅ Codigo : ${codigo}\n✅ Descuento de : ${moneda} ${descuentoActualizado?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}\n`;
            }

            const paymentMessage = paymentMethod === 'efectivo' ? 'Pago en efectivo' : 'Pago por transferencia bancaria';
            const deliveryMessage = tieneProductosConStock
                ? `\n✅ ${deliveryOption === 'delivery' ? 'Envio a domicilio' : 'Retiro personalmente'}`
                : '';

            let trackingSection = '';
            if (trackingLink) {
                trackingSection = `\n\n------------------------------------>\n🛵 *Rastrea tu pedido en tiempo real aquí:*\n${trackingLink}`;
            }

            message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n ${noteMessage}${deliveryMessage}\n✅ ${paymentMessage}\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*${trackingSection}`;
        }

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');

        // 4. Actualizar la URL con el query param del pedido y abrir el modal de rastreo en pantalla
        if (idComandaCreada) {
            try {
                const newUrl = `${currentPathname}?pedido=${idComandaCreada}`;
                window.history.pushState({ path: newUrl }, '', newUrl);
                window.dispatchEvent(new CustomEvent('abrir-tracking', { detail: { idComanda: idComandaCreada } }));
            } catch (e) {
                console.error('Error al actualizar URL tracking:', e);
            }
        }

        clearCart();
        setName('');
        setLocation('');
        setNoteText('');
        setNumeroMesa('');
        setCodigo('');
        setDescuento(0);
        setModalIsOpen(false);
        setModalIsOpen2(false);
        setEnviandoPedido(false);
    };

    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        window.dispatchEvent(new CustomEvent('cart-updated'));
    };

    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
            window.dispatchEvent(new CustomEvent('cart-updated'));
        }
    };

    const tieneProductosConStock = cartItems.some(item => {
        const isService = item.tipo === 'servicio';
        const hasStock = item.stock === undefined || item.stock === null || Number(item.stock) > 0;
        return !isService && hasStock;
    });

    const totalCantidadItems = cartItems.reduce((acc, item) => acc + (Number(item.cantidad) || 1), 0);

    return (
        <div>
            {cartItems.length > 0 && (
                <button onClick={openModal} className='cartIconFixed' title="Ver carrito">
                    <span>{totalCantidadItems}</span>
                    <FontAwesomeIcon icon={faShoppingCart} />
                </button>
            )}

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal}><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ? (
                    <p className='nohay'> No hay productos</p>
                ) : (
                    <>
                        <div className="modal-content-cart">
                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>
                                    {cartItems.map((item, index) => (
                                        <div key={item?.idProducto} className='cardProductCart'>
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {Array.isArray(item?.item) ? (
                                                        item?.item?.map((sabor, idx) => (
                                                            <span key={idx}> {sabor}</span>
                                                        ))
                                                    ) : (
                                                        item?.item && <span>{item.item}</span>
                                                    )}
                                                </span>
                                                <strong>{moneda} {item?.precio?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>
                            <h4>Total: {moneda} {totalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h4>

                            <div className={`deFLexBtns ${esModoLista ? 'dobleBtn' : ''}`}>
                                <button className='btnWpp' onClick={() => openModalConTipo('delivery')}>
                                    Pedir por WhatsApp <img src={whatsappIcon} alt="WhatsApp" />
                                </button>
                                {esModoLista && (
                                    <button className='btnMesa' onClick={() => openModalConTipo('mesa')} title="Hacer pedido en mesa">
                                        <FontAwesomeIcon icon={faUtensils} /> Pedido en Mesa
                                    </button>
                                )}
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className={`modal-cart ${tipoPedido === 'mesa' ? 'modal-mesa-cart' : ''}`}
                            overlayClassName={tipoPedido === 'mesa' ? 'overlay-cart-centered' : 'overlay-cart'}
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2}><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>{tipoPedido === 'mesa' ? 'Elige tu mesa' : 'Agregar Detalles'}</h4>
                            </div>

                            {tipoPedido === 'mesa' ? (
                                <div className="modal-send-form modal-mesa-form">
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Nombre"
                                        className="mesa-input-field"
                                    />
                                    <input
                                        type="text"
                                        id="codigo"
                                        value={codigo}
                                        onChange={(e) => setCodigo(e.target.value)}
                                        placeholder="Codigo de descuento (opcional)"
                                        className="mesa-input-field"
                                    />
                                    <textarea
                                        placeholder="Agrega una nota (opcional)"
                                        value={noteText}
                                        onChange={(e) => setNoteText(e.target.value)}
                                        className="mesa-textarea-field"
                                        rows={3}
                                    />

                                    <div className="mesas-grid-selector">
                                        {mesasParaMostrar.map((m) => {
                                            const esOcupada = m.estado === 'ocupada';
                                            const esSeleccionada = !esOcupada && normalizarMesa(numeroMesa) === normalizarMesa(m.numero);
                                            const tituloMesa = m.numero.startsWith('Mesa') ? m.numero : `Mesa ${m.numero}`;
                                            return (
                                                <div
                                                    key={m.idMesa || m.numero}
                                                    className={`mesa-card-item ${esOcupada ? 'ocupada' : 'disponible'} ${esSeleccionada ? 'selected' : ''}`}
                                                    onClick={() => handleSelectMesa(m)}
                                                >
                                                    <span className="mesa-card-title">{tituloMesa}</span>
                                                    {esOcupada ? (
                                                        <span className="mesa-card-sub">ocupada</span>
                                                    ) : (
                                                        <span className={`mesa-radio-indicator ${esSeleccionada ? 'checked' : 'unchecked'}`}>
                                                            {esSeleccionada && <span className="mesa-radio-blue-dot" />}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={handleWhatsappMessage}
                                        className="btn-finalizar-pedido-mesa"
                                        disabled={enviandoPedido}
                                    >
                                        {enviandoPedido ? 'Generando pedido...' : 'Finalizar pedido'}
                                    </button>
                                </div>
                            ) : (
                                <div className="modal-send-form">
                                    <>
                                        <input
                                            type="text"
                                            id="name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder='Nombre (opcional)'
                                        />
                                        {tieneProductosConStock && (
                                            <div className='deFLexRadio'>
                                                <label>Opciones de entrega</label>
                                                <div>
                                                    <input
                                                        type="radio"
                                                        id="delivery"
                                                        name="deliveryOption"
                                                        value="delivery"
                                                        checked={deliveryOption === 'delivery'}
                                                        onChange={() => setDeliveryOption('delivery')}
                                                    />
                                                    <label htmlFor="delivery">Envío a domicilio</label>
                                                </div>
                                                <div>
                                                    <input
                                                        type="radio"
                                                        id="pickup"
                                                        name="deliveryOption"
                                                        value="pickup"
                                                        checked={deliveryOption === 'pickup'}
                                                        onChange={() => setDeliveryOption('pickup')}
                                                    />
                                                    <label htmlFor="pickup">Retirar personalmente</label>
                                                </div>
                                            </div>
                                        )}
                                        {deliveryOption === 'delivery' && (
                                            <input
                                                type="text"
                                                id="location"
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                                placeholder='Dirección de entrega (calle, número, dpto)'
                                            />
                                        )}
                                        <div className='deFLexRadio'>
                                            <label>Formas de pago</label>
                                            <div>
                                                <input
                                                    type="radio"
                                                    id="efectivo"
                                                    name="paymentMethod"
                                                    value="efectivo"
                                                    checked={paymentMethod === 'efectivo'}
                                                    onChange={() => setPaymentMethod('efectivo')}
                                                />
                                                <label htmlFor="efectivo">Efectivo</label>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    id="transferencia"
                                                    name="paymentMethod"
                                                    value="transferencia"
                                                    checked={paymentMethod === 'transferencia'}
                                                    onChange={() => setPaymentMethod('transferencia')}
                                                />
                                                <label htmlFor="transferencia">Transferencia</label>
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            id="codigo"
                                            value={codigo}
                                            onChange={(e) => setCodigo(e.target.value)}
                                            placeholder='Codigo de descuento (opcional)'
                                        />
                                        <textarea
                                            placeholder="Agrega una nota (opcional)"
                                            value={noteText}
                                            onChange={(e) => setNoteText(e.target.value)}
                                        />
                                        <button
                                            onClick={handleWhatsappMessage}
                                            className='btn'
                                            disabled={enviandoPedido}
                                        >
                                            {enviandoPedido ? 'Generando pedido...' : 'Enviar por WhatsApp'}
                                        </button>
                                    </>
                                </div>
                            )}
                        </Modal>
                    </>
                )}
            </Modal>
            <OrderTrackingModal />

            {/* BOTÓN FLOTANTE DE MESA PARA EL CLIENTE: SOLO SI LA URL CONTIENE ?mesa= Y LA TIENDA ES RESTAURANTE */}
            {Boolean(numeroMesa && esModoLista && new URLSearchParams(routerLocation.search).get('mesa')) && (
                <div className="mesaPillFixed">
                    <button
                        type="button"
                        className="btnMesaCuentaFloating"
                        onClick={() => abrirCuentaCliente(numeroMesa, tienda?.idTienda)}
                        title={`Estás en ${numeroMesa}. Clic para consultar tu cuenta.`}
                    >
                        <span className="mesaFloatingTag">🍽️ {numeroMesa}</span>
                        <span className="mesaFloatingAction"><FontAwesomeIcon icon={faReceipt} /> Ver Cuenta</span>
                    </button>
                </div>
            )}

            {/* MODAL CONSULTA DE CUENTA PARA EL CLIENTE: SOLO SI LA URL CONTIENE ?mesa= Y LA TIENDA ES RESTAURANTE */}
            {Boolean(numeroMesa && esModoLista && new URLSearchParams(routerLocation.search).get('mesa')) && (
                <Modal
                    isOpen={modalCuentaClienteOpen}
                    onRequestClose={() => setModalCuentaClienteOpen(false)}
                    className="modal-cuenta-cliente-card"
                    overlayClassName="overlay-cart-centered"
                >
                <div className="modal-cuenta-cliente-header">
                    <div className="cuenta-cliente-header-info">
                        <span className="cuenta-cliente-chip">🍽️ {numeroMesa}</span>
                        <h4>Cuenta de tu Mesa</h4>
                        <p>{tienda?.nombre || 'Carta Digital'}</p>
                    </div>
                    <div className="cuenta-cliente-header-actions">
                        <button
                            type="button"
                            className="btn-refresh-cuenta-cliente"
                            onClick={() => abrirCuentaCliente(numeroMesa, tienda?.idTienda)}
                            title="Actualizar cuenta en vivo"
                            disabled={loadingCuentaCliente}
                        >
                            <FontAwesomeIcon icon={faSyncAlt} spin={loadingCuentaCliente} />
                        </button>
                        <button
                            type="button"
                            className="btn-cerrar-cuenta-cliente"
                            onClick={() => setModalCuentaClienteOpen(false)}
                            title="Cerrar ventana"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </div>

                <div className="modal-cuenta-cliente-body">
                    {loadingCuentaCliente ? (
                        <div className="cuenta-cliente-loading">
                            <FontAwesomeIcon icon={faSyncAlt} spin className="icon-loading-spin" />
                            <p>Consultando tu cuenta en vivo...</p>
                        </div>
                    ) : comandasMesaCliente.length === 0 ? (
                        <div className="cuenta-cliente-vacia">
                            <FontAwesomeIcon icon={faCheckCircle} className="icon-vacia" />
                            <h5>Sin pedidos pendientes</h5>
                            <p>Aún no hay órdenes activas registradas para <strong>{numeroMesa}</strong>.</p>
                            <button
                                className="btn-comenzar-pedido"
                                onClick={() => {
                                    setModalCuentaClienteOpen(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faUtensils} /> Ver la Carta y Pedir a la Mesa
                            </button>
                        </div>
                    ) : (() => {
                        const totalAcumulado = comandasMesaCliente.reduce((acc, c) => acc + (parseFloat(c.total) || 0), 0);
                        return (
                            <div className="cuenta-cliente-content">
                                <div className="cuenta-cliente-total-card">
                                    <span>Total Consumido</span>
                                    <h3>{moneda} {totalAcumulado.toFixed(2)}</h3>
                                    <small>{comandasMesaCliente.length} {comandasMesaCliente.length === 1 ? 'orden enviada' : 'órdenes enviadas'} a cocina</small>
                                </div>

                                <div className="cuenta-cliente-items-list">
                                    {comandasMesaCliente.map(c => (
                                        <div key={c.idComanda} className="cuenta-cliente-comanda-item">
                                            <div className="comanda-item-top">
                                                <span>Pedido #{c.idComanda}</span>
                                                <span className={`comanda-pill-status ${c.estado}`}>{c.estado}</span>
                                            </div>
                                            <div className="comanda-item-products">
                                                {(c.items || []).map((it, idx) => (
                                                    <div key={idx} className="item-row-prod">
                                                        <span className="qty">{it.cantidad}x</span>
                                                        <span className="title">{it.titulo}</span>
                                                        <span className="price">{moneda} {(Number(it.precio || 0) * Number(it.cantidad || 1)).toFixed(2)}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="cuenta-cliente-bottom-actions">
                                    <button
                                        type="button"
                                        className="btn-pedir-mas-mesa"
                                        onClick={() => setModalCuentaClienteOpen(false)}
                                    >
                                        <FontAwesomeIcon icon={faUtensils} /> Ver Carta / Agregar Productos
                                    </button>
                                </div>

                                <div className="cuenta-cliente-footer-note">
                                    <p>Para solicitar la cuenta o pagar en mesa, puedes avisar al mozo o pedir POS con tarjeta.</p>
                                </div>
                            </div>
                        );
                    })()}
                </div>
            </Modal>
            )}
        </div>
    );
}

